export const FETCH_ALL_NOTIFICATIONS_REQUEST = "FETCH_ALL_NOTIFICATIONS_REQUEST";
export const FETCH_ALL_NOTIFICATIONS_SUCCESS = "FETCH_ALL_NOTIFICATIONS_SUCCESS";
export const FETCH_ALL_NOTIFICATION_FAILURE = "FETCH_ALL_NOTIFICATION_FAILURE";

export const UPDATE_NOTIFICAITON_REQUEST = "UPDATE_NOTIFICAITON_REQUEST";
export const UPDATE_NOTIFICAITON_SUCCESS = "UPDATE_NOTIFICAITON_SUCCESS";
export const UPDATE_NOTIFICAITON_FAILURE = "UPDATE_NOTIFICAITON_FAILURE";

export const SHOULD_SHOW_AND_ALERT_NOTIFICATION = "SHOULD_SHOW_AND_ALERT_NOTIFICATION";
